// extracted by mini-css-extract-plugin
export default {"container":"EbXtFh","recorderFonts":"Up9kZ6","dashboardContainer":"vByN65","mobile":"Ccofi_","sidePanelOpened":"vfrZ8_"};